import React from 'react';
import styles from './TooltipContent.module.css';

const TooltipContent = ({ title, children }) => {
  return (
    <div className={styles.tooltipContent}>
      <div className={styles.tooltipHeader}>
        <h3 className={styles.tooltipTitle}>{title}</h3>
      </div>
      <div className={styles.tooltipBody}>
        {children}
      </div>
    </div>
  );
};

export default TooltipContent;
